import { trigger, state, style, transition, animate } from '@angular/animations';
import { Component, Input } from '@angular/core';

import { TopicData, CriteriumData } from 'src/app/modules/shared/models/Strategy';

@Component({
  selector: 'app-strategy-topics-card',
  templateUrl: './strategy-topics-card.component.html',
  styleUrls: ['./strategy-topics-card.component.scss'],
  animations: [
    trigger('flipState', [
      state(
        'active',
        style({
          transform: 'rotateY(179deg)'
        })
      ),
      state(
        'inactive',
        style({
          transform: 'rotateY(0)'
        })
      ),
      transition('active => inactive', animate('320ms ease-out')),
      transition('inactive => active', animate('320ms ease-in'))
    ])
  ],
  standalone: false
})
export class StrategyTopicsCardComponent {
  @Input() showSampleCompanies: boolean;
  @Input() selected: boolean;
  @Input() card: TopicData | CriteriumData;
  flip = 'inactive';

  get hasSampleCompany(): boolean {
    return typeof this.card.sample_companies !== 'undefined';
  }

  toggleFlip($event: Event): void {
    $event.stopPropagation();
    this.flip = this.flip === 'inactive' ? 'active' : 'inactive';
  }
}
